module.exports = __webpack_public_path__ + "static/media/loader-2.1dbb5970.gif";